module.exports = "/assets/66247daebf8f3ee876425b09d3ae4a13.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/V3.png
// module id = 1912
// module chunks = 0